const delimiter = '&';

export function encodeObject(
  object: { [key: string]: string } | null | undefined,
  queryStringName: string
): string {
  if (object)
    return (
      Object.entries(object)
        ?.map(
          ([key, value]) =>
            `${encodeURIComponent(`${queryStringName}[${key}]`)}=${encodeURIComponent(value)}`
        )
        .join(delimiter) ?? ''
    );

  return '';
}
export function buildStringFromParams(params: { [key: string]: string | number }): string {
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}
